<template>
  <!DOCTYPE html>
  <div>
    <div v-if="message">
      <div class="alert alert-danger">
        <div class="alert-body">
          {{ message }}
        </div>
      </div>
    </div>
    <div v-else>
      <div class="bg-white detail">
        <div class="row">
          <div class="col-12">
            <h1>{{ frmData.name }}</h1>
            <div
              class="head d-flex flex-row justify-content-between pb-1"
              style="border-bottom: 1px solid #edecec;"
            >
              <div
                class="d-flex flex-row"
                style="line-height: 2"
              >
                <span>{{ frmData.datetime }} (GMT+7)</span>
              </div>
              <div class="d-flex flex-row">
                <b-button
                  type="button"
                  class="mr-1 font12"
                  size="sm"
                  variant="green"
                  :to="{ name: 'propagate-edit', params: { id: frmData.id } }"
                > Sửa </b-button>
                <b-button
                  v-if="frmData.status != 5"
                  type="button"
                  class="mr-1 font12"
                  size="sm"
                  variant="blues"
                  @click="updateStatus(5)"
                > Xuất bản </b-button>
                <b-button
                  v-if="frmData.status == 5"
                  type="button"
                  class="mr-1 font12"
                  size="sm"
                  variant="red"
                  @click="updateStatus(7)"
                > Hủy xuất bản </b-button>
              </div>
            </div>
            <div
              class="view mt-1"
              v-html="frmData.content"
            />
            <div class="attach_file">
              <h3 class="fs-3">
                File đính kèm
              </h3>
              <div
                v-if="frmData.attached_files.length > 0"
                class=" mb-1"
              >
                <ul>
                  <li
                    v-for="(item, index) in frmData.attached_files"
                    :key="index"
                  >
                    <a
                      :href="item.full_path"
                      download
                    >{{ item.name }} </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {
  BButton,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import store from '@/store'
import { showToast } from '@core/utils/utils';

export default {
  components: {

    BButton,

  },
  props: {
    propagate_id: null,
  },
  setup(props) {
    const message = ref('');
    const blank = {
      name: '',
      type: '',
      attach_file: [],
      content: '',
      status: 0,
    }
    const frmData = ref(JSON.parse(JSON.stringify(blank)))
    if (props.propagate_id > 0) {
      const id = props.propagate_id;
      store.dispatch('propagate/edit', id).then(response => {
        const result = response.data;
        if (result.code == 200) {
          frmData.value = result.data.frmData
        } else {
          message.value = result.message;
        }
      })
    }

    return {
      frmData,
      message,
    }
  },

  methods: {
    updateStatus(status) {
      this.frmData.status = status;
      store.dispatch('propagate/update', { data: this.frmData, id: this.frmData.id })
        .then(response => {
          const result = response.data;
          if (result.code === 200) {
            showToast(result.message, { variant: 'success' });
            this.$emit('updateList');
          } else if (result.errors) {
            this.$refs.propagateForm.setErrors(result.errors);
          } else {
            showToast(result.message);
          }
        })
    },
  },
}
</script>
